import Swiper from "swiper11";
import {  FreeMode, Navigation} from "swiper11/modules";


const _customerCase = () => {
  const pageMarker = $("._customerCase_");
  if (!pageMarker.length) return;
  
  $('.content-main .tab-content .tab-pane').each(function(_i, _el) {
    $(`#${_el.id} .swiper .swiper-slide`).on('mouseenter',function () {
      $(this).addClass("swiper-slide-active").siblings().removeClass("swiper-slide-active")
  })
    new Swiper(`.case .content-main #${_el.id} .swiper-box .swiper`, {
      modules: [Navigation, FreeMode],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 10,
      watchSlidesProgress: true,
      // centeredSlides: true,
      freeMode: false,
      navigation: {
        nextEl: `.case .content-main #${_el.id} .swiper-box .custom-swiper-navigation .next`,
        prevEl: `.case .content-main #${_el.id} .swiper-box .custom-swiper-navigation .prev`,
      },
      breakpoints:{
        769:{
          direction: 'vertical',
          slidesPerView: 3,
          freeMode: true,
          spaceBetween: 0,
        }
      }
  

    });
  });
  




};

export default _customerCase;
